import { collection, doc, runTransaction, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';
import { validateTableChange } from './dispatchOrders';

export const changeOrderTable = async ({ user, orderId, expectedTable, nextTable }) => {
  const orderRef = doc(db, 'orders', orderId);
  const auditRef = doc(collection(db, 'auditLogs'));
  return runTransaction(db, async (tx) => {
    const snapshot = await tx.get(orderRef);
    if (!snapshot.exists()) throw new Error('El pedido ya no existe.');
    const order = snapshot.data();
    validateTableChange(user, order, expectedTable, nextTable);
    const change = {
      from: order.table || '', to: nextTable,
      byUid: user.uid,
      byName: user.username || user.displayName || user.email || 'Despacho',
      at: serverTimestamp(), auditId: auditRef.id,
    };
    tx.update(orderRef, { table: nextTable, lastTableChange: change, updatedAt: serverTimestamp() });
    tx.set(auditRef, {
      createdAt: serverTimestamp(), module: 'Panel de Despacho', action: 'Cambiar mesa',
      userId: user.uid, userEmail: user.email || '',
      userDisplay: change.byName, user: { uid: user.uid, email: user.email || '', name: change.byName },
      severity: 'info', target: { id: orderId, type: 'order' },
      details: { orderId, from: change.from, to: change.to, userName: change.byName },
    });
  });
};
